<template>
  <div class="app-container activate-result">
    <div class="tit-text tc">
      <img :src="require('@/assets/activate-result.png')">
    </div>
    <p class="content-text tc mt30">
      {{ $t('activate_result_message') }}
    </p>
    <div class="footer_btn">
      <md-button type="primary" @click="btnHandel">
        {{ $t('ok') }}
      </md-button>
    </div>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'
export default {
  name: 'ActivateSelectCard',
  components: {
    [Button.name]: Button
  },
  methods: {
    btnHandel () {
      this.$router.push({
        name: 'Home'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer_btn {
  margin-top: 200px;
}

.tit-text {
  margin-top: 75px;

  img {
    width: 302px;
    height: 242px;
  }
}

.content-text {
  color: #606266;
  padding: 0 20px;
  line-height: 48px;
}
</style>
